const authHost = 'https://sso.hml.minfin.gov.ao';
const host = 'https://leilao.hml.minfin.gov.ao'; //'https://app-ft-plbem-hml.azurewebsites.net';

export const environment = {
  production: true,
  appName: 'Leilão MINFIN',
  baseUrl: 'https://app-bk-plbem-hml.azurewebsites.net',
  lanceServicoUrl: 'https://app-bk-plbem-hml.azurewebsites.net',
  cmsUrl: 'https://cms.hml.minfin.gov.ao',
  cmsAppName: 'plbem',
  utente: {
    authHost,
    authClientId: 'plbem',
    authClientSecret: undefined,
    authRealm: 'contribuinte',
    redirectUri: host,
  },
  painel: {
    authHost,
    authClientId: 'plbem',
    authClientSecret: 'EpzlYq2sg9uZ7gnOxFCKNdzFILyBSsMd',
    authRealm: 'minfin',
    redirectUri: `${host}/painel`,
  },
};
